import { CanActivateFn } from '@angular/router';

export const domainCheckGuardGuard: CanActivateFn = (route, state) => {
  const allowedDomain = "beat22.com";
     if (window.location.hostname === "localhost" || window.location.host === "192.168.1.109:8080") {
      return true;
     } else if (window.location.hostname === "dev.beat22.com") {
      return true;
     } else if (window.location.hostname !== allowedDomain) {
      window.location.href = `https://${allowedDomain}${window.location.pathname}`;
      return false;
    }
    return true
};
